import React, { useEffect, useState } from "react";
import api, { apiErrorMessage } from "@/lib/api";
import useCampaign from "@/lib/useCampaign";
import HomeHero from "@/components/public/HomeHero";
import ProductRail from "@/components/public/ProductRail";
import WhyChooseLiftedSection from "@/components/public/WhyChooseLiftedSection";
import EcosystemFlowSection from "@/components/public/EcosystemFlowSection";
import OrbitalEcosystem from "@/components/public/OrbitalEcosystem";
import SuppliesIntroSection from "@/components/public/SuppliesIntroSection";
import AffiliateIntroSection from "@/components/public/AffiliateIntroSection";
import EcosystemPreviewSection from "@/components/public/EcosystemPreviewSection";
import HesitationRecovery from "@/components/public/HesitationRecovery";

/**
 * Phase 11.5 / 12.3 — Customer-first homepage with pre-rail retention strip.
 */
export default function HomeLATM() {
  const [bundle, setBundle] = useState(null);
  const [err, setErr] = useState("");
  useCampaign();

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/shop/featured"); setBundle(data); }
      catch (e) { setErr(apiErrorMessage(e)); }
    })();
  }, []);

  return (
    <div data-testid="home-latm" className="relative">
      <HomeHero />

      <section data-testid="home-pre-rail-actions" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-2 pb-4">
        <HesitationRecovery />
      </section>

      <ProductRail id="home-new-releases" testid="home-new-releases"
        eyebrow="New releases" title="Just dropped."
        blurb="The latest from the LiftedAtTheMoment catalog."
        products={bundle?.new_releases || []} ctaTo="/shop?sort=newest"
        ctaLabel="See all new" eventKey="new_release_click" />

      <ProductRail id="home-best-sellers" testid="home-best-sellers"
        eyebrow="Best sellers" title="Community favorites."
        blurb="The Lifted pieces our community keeps coming back to."
        products={bundle?.best_sellers || []} ctaTo="/shop"
        ctaLabel="Shop best sellers" eventKey="best_seller_click" />

      <ProductRail id="home-gear" testid="home-gear"
        eyebrow="Lifted Gear" title="Streetwear meets everyday lifts."
        blurb="Apparel built for the lifestyle. Capsule drops, seasonal releases, daily essentials."
        products={bundle?.gear || []} ctaTo="/collections/lifted-gear"
        ctaLabel="Shop Lifted Gear" eventKey="gear_click" maxItems={4} />

      <ProductRail id="home-accessories" testid="home-accessories"
        eyebrow="Lifted Accessories" title="Everyday carry."
        blurb="Rolling papers, grinders, bongs, hand pipes, vaporizers, and more — curated for the Lifted lifestyle."
        products={bundle?.accessories || []} ctaTo="/collections/lifted-accessories"
        ctaLabel="Shop accessories" eventKey="accessory_click" maxItems={4} />

      <EcosystemFlowSection id="home-ecosystem-flow" />
      <SuppliesIntroSection id="home-supplies" />
      <AffiliateIntroSection id="home-affiliate" />
      {/* Phase 8.4 — Replace prior bubbles/box diagram with the approved
          orbital "Lifted Ecosystem" hub layout. */}
      <OrbitalEcosystem id="home-ecosystem-orbital" />
      <WhyChooseLiftedSection id="home-why-lifted" />

      {err ? (
        <div data-testid="home-latm-error" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pb-8 text-rose-300 text-sm">
          {err}
        </div>
      ) : null}
    </div>
  );
}
